import Vue from "vue";
import Router from "vue-router";
import HomeView from "./views/HomeView.vue";
import HotspotsView from "./views/HotspotsView.vue";
import LoginView from "./views/LoginView.vue";
import UserProfileView from "./views/UserProfileView.vue";
import SupportView from "./views/SupportView.vue";
import ThemeView from "./views/ThemeView.vue";
import ThemeSettingsView from "./views/ThemeSettingsView.vue";
import ErrorsView from "./views/ErrorsView.vue";
import AdvertisingView from "./views/AdvertisingView.vue";
import AdvertisingSettingsView from "./views/AdvertisingSettingsView.vue";
import StatisticsView from "./views/StatisticsView.vue";
import DetailingView from "./views/DetailingView.vue";
// import TariffView from "./views/TariffView.vue";
import StatisticsGeneralMain from "./components/statistics/StatisticsGeneralMain.vue";
import StatisticsVisits from "./components/statistics/StatisticsVisits.vue";
import StatisticsGone from "./components/statistics/StatisticsGone.vue";
import StatisticsTemplates from "./components/statistics/StatisticsTemplates.vue";
import PollsView from "./views/PollsView.vue";
import PollSettingsView from "./views/PollSettingsView.vue";
import store from "./store";
import calltouch from '@/plugins/calltouch';

Vue.use(Router);

const routes = [
  { name: "login", path: "/login", component: LoginView },
  {
    name: "home",
    path: "/",
    component: HomeView,
    redirect: "/hotspot",
    meta: { requiresAuth: true },
    children: [
      {
        name: "hotspot",
        path: "/hotspot",
        component: HotspotsView
      },
      {
        name: "theme",
        path: "/theme",
        component: ThemeView
      },
      {
        name: "themeCreate",
        path: "/theme/item/",
        component: ThemeSettingsView
      },
      {
        name: "themeSettings",
        path: "/theme/item/:id",
        component: ThemeSettingsView
      },
      {
        name: "advertising",
        path: "/advertising",
        component: AdvertisingView
      },
      {
        name: "advCreate",
        path: "/advertising/item/",
        component: AdvertisingSettingsView
      },
      {
        name: "advSettings",
        path: "/advertising/item/:id",
        component: AdvertisingSettingsView
      },
      {
        name: "profile",
        path: "/profile",
        component: UserProfileView
      },
      {
        name: "support",
        path: "/support",
        component: SupportView
      },
      {
        name: "detailing",
        path: "/detailing",
        component: DetailingView
      },
      // {
      //   name: "tariff",
      //   path: "/tariff",
      //   component: TariffView
      // },
      {
        name: "statistics",
        path: "/statistics",
        redirect: "/statistics/general",
        component: StatisticsView,
        children: [
          {
            name: "statisticsGeneral",
            path: "/statistics/general",
            component: StatisticsGeneralMain,
            props: true
          },
          {
            name: "statisticsVisits",
            path: "/statistics/visits",
            component: StatisticsVisits
          },
          {
            name: "statisticsGone",
            path: "/statistics/gone",
            component: StatisticsGone
          },
          {
            name: "statisticsTemplates",
            path: "/statistics/templates",
            component: StatisticsTemplates,
            props: true
          }
        ]
      },
      {
        name: "polls",
        path: "/polls",
        component: PollsView
      },
      {
        name: "pollSettings",
        path: "/poll/item/:id",
        component: PollSettingsView
      },
      {
        name: "pollCreate",
        path: "/poll/item/",
        component: PollSettingsView
      }
    ]
  },
  { name: "error", path: "/*", component: ErrorsView, props: true }
];

const router = new Router({
  mode: "history",
  scrollBehavior: () => ({ x: 0, y: 0 }),
  routes: routes
});

router.beforeEach((to, from, next) => {
  // если для пути требуется авторизация проверяем загружен ли user
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters.loggedIn) {
      store
        .dispatch("userLoad")
        .then(() => {
          store.commit("SET_LOGGED_IN", true);
          next();
        })
        .catch(error => {
          // TODO возможно нужно делать logout
          // store.dispatch("clearUserData");
          next({
            name: "error",
            params: {
              error:
                "<div class='error--text'>" +
                error +
                "</div><a href='/api/auth/logout'>Выход</a>"
            }
          });
        });
    } else {
      next();
    }
  } else {
    next();
  }
  if (to.name === 'login') calltouch.remove()
  else calltouch.add()
});

export default router;
